exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".simple-white-container__simpleContainer___265zr {\n  background: #fff;\n  padding: 20px;\n  box-shadow: 0 0 25px #797979;\n  border-radius: 5px; }\n", ""]);

// exports
exports.locals = {
	"simpleContainer": "simple-white-container__simpleContainer___265zr"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Containers/SimpleWhiteContainer/simple-white-container.scss
// module id = 635
// module chunks = 0